import styled from "styled-components";
import {JackpotWidgetClockLabelDefaultBox} from "./jackpot-widget-clock-label.default.box";

export const JackpotWidgetClockLabelMrGreenBox = styled(JackpotWidgetClockLabelDefaultBox)`
    color: ${({theme}) => theme.colors.textDark };
`;
